import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { contractAssetRentRequest } from '@api/assetsRent';

import { IContractRequestParams } from '@interfaces/rent/dto/assetRentDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateContractAssetRentRequest = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const { mutate: contractAssetRentRequestCard } = useMutation<IContractRequestParams>({
		mutationKey: [ASSET_RENT_REQUEST_CARD, id],
		mutationFn: ({ id, comment }: IContractRequestParams) => contractAssetRentRequest(id, comment),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentProposedDatesForItemSuccess,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}
		},
	});

	return {
		contractAssetRentRequest: (
			contractAssetRentRequestCard as unknown as UseMutateFunction<any, any, IContractRequestParams, any>
		),
	};
};
